module.exports = "/images/milano-13.jpg";